module.exports = "/virtual-football-league/img/amblems/left/logos/Gra.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Gra.png
// module id = 2096
// module chunks = 4